import { useQuery } from "@tanstack/react-query";

import { api } from "../../api/client";

const PLATFORM_ADMIN_ROLE = "orixen-platform-admin";

/** True when the signed-in user has the platform-admin realm role (writes).
 *  Reads /me; defaults to false until loaded (write controls stay disabled). */
export function useIsPlatformAdmin(): boolean {
  const q = useQuery({
    queryKey: ["me"],
    queryFn: () => api.me(),
    staleTime: 5 * 60_000,
  });
  return Boolean(q.data?.realm_roles?.includes(PLATFORM_ADMIN_ROLE));
}
